module.exports = __webpack_public_path__ + "img/blockchain_4.9af3f0c7.png";